import { createStyles, makeStyles } from '@material-ui/core';
export var useFormStyle = makeStyles(function (theme) {
    return createStyles({
        fab: {
            margin: theme.spacing(2, 2, 3, 2)
        },
        groupWrapper: {
            overflow: "hidden",
        },
    });
});
//# sourceMappingURL=form.style.js.map